import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { LoginButton } from "../Common Modules/Common Modules";
import { useNavigate } from "react-router-dom";
const ForgotPasswordForm = ({ onCaptchaVerification, handleSubmit, email, setEmail }) => {
  // const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showCheckIcon, setShowCheckIcon] = useState(false);

  const navigate = useNavigate();


  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const backtoLogin = () => {
    navigate("/");
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50%",
        height: "300px",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          textAlign: "left",
          color: "#333",
        }}
      >


        {/* Main Title */}
        <h2
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            marginBottom: "16px",
            color: "#000",
          }}
        >
          Forgot Password?
        </h2>

        {/* Description */}
        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
            color: "#615d5dff",
            marginBottom: "24px",
            fontWeight: 500,
          }}
        >
          Enter an email associated with your account. We'll send you a password reset link if it matches.
        </p>

        {/* Form */}
        {/* <Form> */}
        <Form.Group controlId="emailInput">
          <Form.Label
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              marginBottom: "8px",
              display: "block",
            }}
          >
            Email Address
          </Form.Label>

          {/* Flex wrapper to align input and icon */}
          <div
            style={{
              display: "flex",
              alignItems: "center", // Vertically centers the icon
              position: "relative",
              width: "100%",
              height: "48px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <Form.Control
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (e.target.value && validateEmail(e.target.value)) {
                  setShowCheckIcon(true);
                  setEmailError("");
                } else {
                  setShowCheckIcon(false);
                }
              }}
              isInvalid={!!emailError}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                borderRadius: "8px",
                fontSize: "14px",
                padding: "0 12px",
                boxShadow: "none",
                outline: "none",
              }}
              className="border-0 focus:ring-0"
            />

            {/* Show tick icon only when valid */}
            {showCheckIcon && (
              <span
                style={{
                  position: "absolute",
                  right: "12px", // Matches input padding
                  pointerEvents: "none", // Prevents interference with input
                  color: "green",
                  fontSize: "18px",
                }}
              >
                ✓
              </span>
            )}
          </div>

          {/* Error Feedback */}
          <Form.Control.Feedback type="invalid" style={{ display: emailError ? "block" : "none" }}>
            {emailError}
          </Form.Control.Feedback>
        </Form.Group>

        {emailError && (
          <div
            style={{
              fontSize: "12px",
              color: "red",
              marginTop: "4px",
            }}
          >
            {emailError}
          </div>
        )}
        {/* <div style={{ display: "flex", justifyContent: "center" }}>
            <LoginButton
              onClick={handleSubmit}
              buttonText={"Retrieve Password"} // Corrected typo
              icon={false}
            />
          </div> */}


        <button
        type="button"
        style={{
          marginTop: "20px",
          width: "100%",
          height: "48px",
          backgroundColor: "#166534",
          color: "#FEF08A",
          border: "none",
          outline: "none",
          borderRadius: "8px",
          fontSize: "0.95rem",
          fontWeight: 500,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          transition: "background-color 0.2s",
        }}
        onClick={handleSubmit}
      >
        Send a reset password link
        <FontAwesomeIcon
          icon={faArrowRight}
          style={{ marginRight: "8px", color: "#FEF08A", fontWeight: 500 }}
        />
      </button>

        {/* </Form> */}

        {/* Back to Login Link */}
        <div
          style={{
            marginTop: "24px",
            textAlign: "center",
          }}
        >
          <button onClick={backtoLogin} style={{ color: "black", textDecoration: "none", background: "none", border: "none", cursor: "pointer", fontSize: "14px" }}>
          <FontAwesomeIcon
            icon={faArrowLeft}
            
          />
          {" "} Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;